module.exports = __webpack_public_path__ + "static/media/teo-logov3-400px.befece34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teo-logov3-400px.png
// module id = 1866
// module chunks = 0